<template>
  <div class="flex-grow flex flex-col overflow-x-auto min-w-0">

    <portal to="mobile-header" v-slot="{didToggle, toggle}">
      <div class="flex-grow min-w-0 flex flex-col align-center h-12" @click="didToggle">
        <div class="align-center text-lg font-bold font-display inline-flex items-center justify-center sm:hidden -mr-4 px-4">
          <div class="text-center truncate">
            {{ homeNumber.label || homeNumber.formattedNumber || homeNumber.number }}
          </div>
          <svg class="ml-1 h-3 w-3 transform duration-300" :class="{'rotate-180': toggle}" stroke="#9FA6B2" fill="#9FA6B2" viewBox="0 0 24 24">
            <use href="/images/regular.svg#angle-down"></use>
          </svg>
        </div>
        <div class="text-center text-xs text-gray-500" v-if="homeNumber.label">
          {{ homeNumber.formattedNumber || homeNumber.number }} • {{ homeNumber.homeLanguage.name }}
        </div>
      </div>
    </portal>

    <portal to="mobile-extras">
      <div class="text-center mt-1 mb-2">
        <button
          @click="callAction"
          type="button"
          class="inline-flex items-center px-4 py-2 border border-transparent text-sm leading-5 font-lg rounded-md text-white bg-indigo-600 hover:bg-indigo-500 focus:outline-none focus:ring-indigo focus:border-indigo-700 active:bg-indigo-700 transition duration-150 ease-in-out cursor-pointer mr-4"
        >
          Call
        </button>

        <RouterLink :to="{name: 'homeNumberEdit', params: { canGoBack: true }}" tag="button" type="button" class="inline-flex items-center px-4 py-2 border border-transparent text-sm leading-5 font-lg rounded-md text-white bg-indigo-600 hover:bg-indigo-500 focus:outline-none focus:ring-indigo focus:border-indigo-700 active:bg-indigo-700 transition duration-150 ease-in-out cursor-pointer">
          Edit
        </RouterLink>
      </div>
    </portal>

    <div class="hidden sm:block px-4 sm:px-6 md:px-8 pt-2 pb-6 md:py-6 border-b border-gray-200">
      <div>
        <nav class="sm:hidden">
          <a href="#" class="flex items-center text-sm leading-5 font-medium text-gray-500 hover:text-gray-700 transition duration-150 ease-in-out">
            <svg class="flex-shrink-0 -ml-1 mr-1 h-5 w-5 text-gray-400" fill="currentColor" viewBox="0 0 20 20">
              <path fill-rule="evenodd" d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z" clip-rule="evenodd"/>
            </svg>
            Back
          </a>
        </nav>
      </div>
      <div class="mt-2 md:flex md:items-center md:justify-between">
        <div class="flex-1 min-w-0">
          <h2 class="text-2xl font-bold leading-7 text-gray-900 sm:text-3xl sm:leading-9 sm:truncate">
            {{ homeNumber.label || homeNumber.formattedNumber || homeNumber.number }}
          </h2>
          <div class="mt-1 flex sm:mt-0 flex-row sm:flex-wrap text-sm leading-5 text-gray-500">
            <div class="mt-2 flex items-center text-sm leading-5 text-gray-500 sm:mr-6">
              <svg class="flex-shrink-0 mr-1.5 h-4 w-4 text-gray-400" fill="currentColor" viewBox="0 0 20 20">
                <use href="/images/solid.svg#phone-rotary"></use>
              </svg>
              {{ homeNumber.formattedNumber || homeNumber.number }}
            </div>
            <div v-if="homeNumber.students.length > 0" class="mt-2 flex items-center text-sm leading-5 text-gray-500 sm:mr-6 flex-wrap">
              <svg class="flex-shrink-0 mr-1.5 h-4 w-4 text-gray-400" fill="currentColor" viewBox="0 0 20 20">
                <use href="/images/solid.svg#user-graduate"></use>
              </svg>
              <span v-for="(student, index) in homeNumber.students" :key="student.id">
                <router-link :to="{ name: 'student', params: { studentId: student.id } }" class="text-gray-500 hover:text-gray-700 transition duration-150 ease-in-out underline">
                  <StudentName :student="student" v-slot="{ display }">{{ display }}</StudentName>
                </router-link><!--
                --><SeriesJoiner
                  :list="homeNumber.students"
                  :index="index" v-slot="{joiner}"
                  >{{ joiner }}</SeriesJoiner>
              </span>
            </div>
            <div v-else class="mt-2 flex items-center text-sm leading-5 text-gray-500 sm:mr-6">
              <svg class="flex-shrink-0 mr-1.5 h-4 w-4 text-gray-400" fill="currentColor" viewBox="0 0 20 20">
                <use href="/images/solid.svg#user-graduate"></use>
              </svg>
              No students attached
            </div>
            <Get :object="homeNumber" get="homeLanguage" v-slot="{ found }">
            <div class="mt-2 flex items-center text-sm leading-5 text-gray-500 sm:mr-6">
              <svg class="flex-shrink-0 mr-1.5 h-4 w-4 text-gray-400" fill="currentColor" viewBox="0 0 20 20">
                <use href="/images/solid.svg#globe-americas"></use>
              </svg>
              {{ found ? found.name : 'No language set' }}
            </div>
            </Get>
          </div>
        </div>
        <div class="mt-4 flex-shrink-0 flex md:mt-0 md:ml-4">
          <span class="shadow-sm rounded-md">
            <RouterLink :to="{name: 'homeNumberEdit', params: { canGoBack: true }}" tag="button" type="button" class="inline-flex items-center px-4 py-2 border border-gray-300 text-sm leading-5 font-medium rounded-md text-gray-700 bg-white hover:text-gray-500 focus:outline-none focus:ring-blue focus:border-blue-300 active:text-gray-800 active:bg-gray-50 transition duration-150 ease-in-out cursor-pointer">
              Edit
            </RouterLink>
          </span>
          <span class="ml-3 shadow-sm rounded-md">
            <button
            @click="callAction"
            type="button"
            class="inline-flex items-center px-4 py-2 border border-transparent text-sm leading-5 font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-500 focus:outline-none focus:ring-indigo focus:border-indigo-700 active:bg-indigo-700 transition duration-150 ease-in-out">
              Call
            </button>
          </span>
        </div>
      </div>
    </div>

    <BottomScroll :scrollWatcher="scrollWatcher" class="overflow-y-auto scrollbar shadow-inner flex-grow">
      <CommunicationList
        class="max-w-4xl mx-auto"
        :communications="communications"
        :didLoadMore="fetchMore"
      />
    </BottomScroll>
    <div class="px-4 sm:px-6 md:px-8 pt-2 pb-4 md:py-4 border-t border-gray-200">
      <MessageForm
        :homeLanguages="homeLanguages"
        :homeNumberId="homeNumberId"
        :moods="moods"
        :teamId="teamId"
      />
    </div>
    <RouterView :homeNumber="homeNumber" :homeLanguages="homeLanguages" :students="students"/>
  </div>
</template>

<script>
import gql                          from 'graphql-tag'
import _get from 'lodash-es/get'
import _map from 'lodash-es/map'
import _nth from 'lodash-es/nth'
import _max from 'lodash-es/max'
import _min from 'lodash-es/min'
import _uniqBy from 'lodash-es/uniqBy'
import _orderBy from 'lodash-es/orderBy'

import { preloadMany } from '@/preloader'
import { tz }                       from '@/tz'

import BottomScroll                 from '@/components/BottomScroll.vue'
import CommunicationList            from '@/components/CommunicationList.vue'
import Container                    from '@/components/Container.vue'
import ArchivedBanner               from '@/components/ArchivedBanner.vue'
import BlockedBanner                from '@/components/BlockedBanner.vue'
import DeletedBanner                from '@/components/DeletedBanner.vue'
import MessageForm                  from '@/components/MessageForm.vue'
import PanelDropdown                from '@/components/PanelDropdown.vue'
import PageHeader                   from '@/components/PageHeader.vue'
import Page                         from '@/pages/Page.vue'
import StudentName                  from '@/components/StudentName.vue'
import SeriesJoiner                 from '@/components/SeriesJoiner.vue'
import Get                          from '@/snippets/Get.vue'


import CommunicationListQuery       from '@/queries/CommunicationList.gql'
import HomeLanguagesQuery           from '@/queries/HomeLanguages.gql'
import HomeNumberQuery              from '@/queries/HomeNumber.gql'
import MoodsQuery                   from '@/queries/Moods.gql'
import TeacherPhoneNumberQuery      from '@/queries/TeacherPhoneNumber.gql'
import HomeNumberEditPage           from '@/queries/HomeNumberEditPage.gql'

import HomeNumberArchiveMutation    from '@/mutations/HomeNumberArchive.gql'
import HomeNumberBlockMutation      from '@/mutations/HomeNumberBlock.gql'
import HomeNumberCleanseMutation    from '@/mutations/HomeNumberCleanse.gql'
import HomeNumberDeleteMutation     from '@/mutations/HomeNumberDelete.gql'
import PhoneCallCreate              from '@/mutations/PhoneCallCreate.gql'

import HomeNumberSubscription       from '@/subscriptions/HomeNumber.gql'
import NewCommunicationSubscription from '@/subscriptions/NewCommunication.gql'


const preloadQueries = (to) => {
  return [
    {
      query: CommunicationListQuery,
      queryName: 'communicationList',
      variables: {
        tz: tz(),
        homeNumberId: to.params.homeNumberId
      },
      fetchPolicy: 'network-only'
    },
    {
      query: HomeLanguagesQuery,
      queryName: 'homeLanguages',
      variables: {
        tz: tz(),
        id: to.params.homeNumberId
      },
      fetchPolicy: 'network-only'
    },
    {
      query: TeacherPhoneNumberQuery,
      queryName: 'teacherPhoneNumber',
      skip: !(to.query.teacherPhoneNumberId),
      variables: {
        id: to.query.teacherPhoneNumberId
      },
      fetchPolicy: 'network-only'
    },
    {
      query: HomeNumberQuery,
      queryName: 'homeNumber',
      variables: {
        tz: tz(),
        id: to.params.homeNumberId
      },
      fetchPolicy: 'network-only'
    },
    {
      query: MoodsQuery,
      queryName: 'moods',
      teamId: to.params.teamId,
      fetchPolicy: 'network-only'
    }
  ]
}

export default {
  components: {
    BottomScroll,
    CommunicationList,
    Container,
    ArchivedBanner,
    BlockedBanner,
    DeletedBanner,
    Get,
    MessageForm,
    PanelDropdown,
    PageHeader,
    Page,
    SeriesJoiner,
    StudentName,
  },

  props: {
    homeNumberId: {
      required: true
    },
    currentUser: {
      required: true
    },
    teamId: {
      required: true
    },
    teacherPhoneNumberId: {
      required: false,
      default: null
    },
  },

  data() {
    return {
      scrollWatcher: new Date,
      students: [],
      homeLanguages: [],
      bus: Bus
    }
  },

  mounted() {
    this.$apollo.mutate({
      mutation: gql`mutation($homeNumberId: ID!) {
        conversationMarkRead(homeNumberId: $homeNumberId) {
          id
          hasUnreads
        }
      }`,
      variables: {
        homeNumberId: this.homeNumberId
      }
    })
  },

  beforeRouteEnter(to, from, next) {
    preloadMany({
      queries: preloadQueries(to),
      callback: next
    })
  },

  beforeRouteUpdate(to, from, next) {
    console.info(to.params)
    console.info(from.params)
    if (to.params.homeNumberId === from.params.homeNumberId) {
      next()
    } else {
      preloadMany({
        queries: preloadQueries(to),
        callback: next,
        mountedVm: this
      })
    }
  },

  computed: {
    actionsDropdownItems() {
      if ( _get(this.homeNumber, 'archivedAt') ) {
        return [
          this.callingDropdownItem,
          { text: 'Edit this number', to: { name: 'homeNumberEdit' } },
          { text: 'Un-archive it', click: this.cleanseHomeNumber },
          { text: 'Block it', click: this.blockHomeNumber },
          { text: 'Put it in the trash', click: this.deleteHomeNumber }
        ]
      } else if ( _get(this.homeNumber, 'blockedAt') ) {
        return [
          this.callingDropdownItem,
          { text: 'Edit this number', to: { name: 'homeNumberEdit' } },
          { text: 'Archive it', click: this.archiveHomeNumber },
          { text: 'Un-block it', click: this.cleanseHomeNumber },
          { text: 'Put it in the trash', click: this.deleteHomeNumber }
        ]
      } else if ( _get(this.homeNumber, 'deletedAt') ) {
        return [
          this.callingDropdownItem,
          { text: 'Edit this number', to: { name: 'homeNumberEdit' } },
          { text: 'Archive it', click: this.archiveHomeNumber },
          { text: 'Block it', click: this.blockHomeNumber },
          { text: 'Un-trash it', click: this.cleanseHomeNumber }
        ]
      } else {
        return [
          this.callingDropdownItem,
          { text: 'Edit this number', to: { name: 'homeNumberEdit' } },
          { text: 'Archive it', click: this.archiveHomeNumber },
          { text: 'Block it', click: this.blockHomeNumber },
          { text: 'Put it in the trash', click: this.deleteHomeNumber }
        ]
      }
    },

    communications() {
      const rawList = _get(this, 'communicationList.list')

      if (rawList === null) {
        return []
      } else {
        return _orderBy(rawList, ['insertedAt', 'desc'])
      }
    },

    filterDisplay() {
      if (this.$route.query.teacherPhoneNumberId === undefined) {
        return 'everyone'
      } else {
        return _get(this, 'teacherPhoneNumber.displayName')
      }
    },

    filterItems() {
      const everyone = [{text: 'everyone', to: {name: 'homeNumber'}}]
      var convos = _get(this.homeNumber, 'conversations', [])
      var rest = _map(convos, (item) => {
        return {
          text: _get(item, 'teacherPhoneNumber.displayName'),
          to: {query: {teacherPhoneNumberId: _get(item, 'teacherPhoneNumber.id')}}
        }
      })

      return everyone.concat(rest)
    },

    isNormalStatus() {
      return
        !_get(this, 'homeNumber.archivedAt')
        && !_get(this, 'homeNumber.blockedAt')
        && !_get(this, 'homeNumber.deletedAt')
    },

    labelDisplay() {
      return _get(this, 'homeNumber.label') || _get(this, 'homeNumber.formattedNumber') || _get(this, 'homeNumber.number')
    },

    largestCommunicationId() {
      return _get(_nth(this.communications, -1), 'id')
    },

    largestDatetime() {
      var datetimes = _map(this.communications, 'insertedAt')
      return _max(datetimes)
    },

    noCommunications() {
      return this.communications.length < 1
    },

    numberDisplay() {
      if (_get(this, 'homeNumber.label')) {
        return _get(this, 'homeNumber.formattedNumber') || _get(this, 'homeNumber.number')
      } else {
        return ''
      }
    },

    smallestDatetime() {
      var datetimes = _map(this.communications, 'insertedAt')
      return _min(datetimes)
    }
  },

  methods: {
    archiveHomeNumber() {
      this.$apollo.mutate({
        mutation: HomeNumberArchiveMutation,
        variables: {
          id: this.homeNumberId
        }
      })
    },

    blockHomeNumber() {
      this.$apollo.mutate({
        mutation: HomeNumberBlockMutation,
        variables: {
          id: this.homeNumberId
        }
      })
    },

    cleanseHomeNumber() {
      this.$apollo.mutate({
        mutation: HomeNumberCleanseMutation,
        variables: {
          id: this.homeNumberId
        }
      })
    },

    callAction() {
      console.log("got here")
      if ( _get(this, 'homeNumber.canMakeCallTo') && _get(this, 'homeNumber.canReceiveCallFrom') ) {
        console.log("creating call")
        this.createPhoneCall()
      } else {
        console.log("settings")
        this.$router.push({ name: 'settings' })
      }
    },

    createPhoneCall() {
      this.$apollo.mutate({
        mutation: PhoneCallCreate,
        variables: {
          homeNumberId: this.homeNumberId
        }
      }).then((data) => {
        Bus.$emit('flash-message', {text: 'Call initiated to your forwarding number', type: 'success'})
      }).catch((error) => {
        Bus.$emit('flash-message', {text: 'Unable to initiate phone call', type: 'error'})
      })
    },

    deleteHomeNumber() {
      this.$apollo.mutate({
        mutation: HomeNumberDeleteMutation,
        variables: {
          id: this.homeNumberId
        }
      })
    },

    fetchMore() {
      this.$apollo.queries.communicationList.fetchMore({
        variables: {
          tz: tz(),
          homeNumberId: this.homeNumberId,
          teacherPhoneNumberId: this.$route.query.teacherPhoneNumberId,
          beforeDatetime: this.smallestDatetime
        },
        skip() {
          return (this.smallestDatetime != null)
        },
        updateQuery: (previousResult, {fetchMoreResult}) => {
          const newList = fetchMoreResult.communicationList.list
          const newCount = fetchMoreResult.communicationList.count

          return {
            communicationList: {
              __typename: previousResult.communicationList.__typename,
              list: _uniqBy([...newList, ...previousResult.communicationList.list], 'id'),
              count: newCount,
              remaining: previousResult.communicationList.remaining
            }
          }
        }
      })
    },

  },

  apollo: {
    homeNumber: {
      query: HomeNumberQuery,
      variables() {
        return {
          tz: tz(),
          id: this.homeNumberId
        }
      },
      fetchPolicy: 'cache-first',
      subscribeToMore: {
        document: HomeNumberSubscription,
        variables() {
          return {
            homeNumberId: this.homeNumberId,
            tz: tz()
          }
        }
      }
    },

    moods: {
      query: MoodsQuery,
      variables() {
        return {
          teamId: this.teamId
        }
      }
    },

    homeLanguages: {
      query: HomeLanguagesQuery
    },

    teacherPhoneNumber: {
      query: TeacherPhoneNumberQuery,
      variables() {
        return { id: this.$route.query.teacherPhoneNumberId }
      },
      skip() {
        return !(this.$route.query.teacherPhoneNumberId)
      }
    },

    homeNumberEditPage: {
      query: HomeNumberEditPage,
      variables() {
        return {
          teamId: this.teamId
        }
      },
      fetchPolicy: 'cache-first',
      manual: true,
      result ({data}) {
        this.homeLanguages = data.homeLanguages,
        this.students = data.students
      }
    },

    communicationList: {
      query: CommunicationListQuery,
      variables() {
        return {
          tz: tz(),
          homeNumberId: this.homeNumberId,
          teacherPhoneNumberId: this.$route.query.teacherPhoneNumberId
        }
      },
      subscribeToMore: {
        document: NewCommunicationSubscription,
        variables() {
          return {
            homeNumberId: this.homeNumberId,
            tz: tz()
          }
        },

        result(data) {
          this.scrollWatcher = new Date
        },

        updateQuery: (previousResult, {subscriptionData}) => {
          const newList = [subscriptionData.data.newCommunication]

          return {
            communicationList: {
              __typename: previousResult.communicationList.__typename,
              list: _uniqBy([...previousResult.communicationList.list, ...newList], 'id'),
              count: previousResult.communicationList.count,
              remaining: previousResult.communicationList.remaining
            }
          }
        }
      }
    }
  }

}
</script>
